import { Translation, QRType } from '../types';

export const tr: Translation = {
  nav: {
    generator: 'Oluşturucu',
    scanner: 'Tarayıcı',
    mobile: 'Mobilde dene',
    blog: 'Blog',
    langSelect: 'Dil Seç',
  },
  pageTitles: {
    generator: 'Ücretsiz Online QR Kod Oluşturucu',
    scanner: 'Online QR Kod Tarayıcı',
    textToQr: 'Metinden QR Koda Dönüştürücü',
    linkToQr: 'Bağlantıdan QR Kod Oluşturucu',
  },
  pageMeta: {
    generator: {
      title:
        'Ücretsiz QR Kod Oluşturucu — Online QR Kod Oluştur (Kayıt Yok, Filigran Yok, PNG/SVG/PDF) | YesQRCode',
      description:
        'YesQRCode ile ücretsiz olarak online QR kod oluşturun. URL, metin, Wi‑Fi, vCard ve daha fazlasını üretin. Yüksek kaliteli PNG, SVG veya PDF indirin. Kayıt yok, giriş yok, filigran yok — hızlı, güvenli ve sonsuza dek ücretsiz.',
      keywords: [
        'qr kod oluşturucu',
        'ücretsiz qr kod oluşturucu',
        'online qr kod oluştur',
        'qr kod yapma',
        'qr kod png',
        'qr kod svg',
        'qr kod pdf',
        'wifi qr kod oluşturucu',
        'vcard qr kod oluşturucu',
        'kayıtsız qr oluşturucu',
      ],
    },
    scanner: {
      title:
        'Online QR Kod Tarayıcı — Görselden veya Kameradan Tara (Güvenli, Kayıt Yok) | YesQRCode',
      description:
        'QR kodları ve barkodları ücretsiz olarak online tarayın. Bir görsel yükleyin veya kameranızı kullanın. Tüm işlem yerel olarak yapılır, yükleme yoktur. Güvenli, hızlı, kayıt yok, giriş yok ve tamamen ücretsiz.',
      keywords: [
        'qr kod tarayıcı',
        'online qr tara',
        'online qr okuyucu',
        'görselden qr tara',
        'online barkod tara',
        'güvenli qr tarayıcı',
        'yüklemesiz qr tarayıcı',
        'ücretsiz qr tarayıcı',
        'tarayıcıda qr tarama',
        'kayıtsız qr tarayıcı',
      ],
    },
    textToQr: {
      title: 'Metinden QR | Notları QR Koda Çevirin',
      description:
        'Metin parçalarını, notları veya mesajları paylaşılabilir QR kodlara dönüştürün. Tasarımınızı özelleştirin ve PNG, SVG veya PDF olarak anında dışa aktarın; kayıt gerekmez.',
      keywords: ['metinden qr', 'metin qr oluşturucu', 'not qr kod', 'mesaj qr', 'online qr dönüştürücü', 'ücretsiz metin qr'],
    },
    linkToQr: {
      title: 'Bağlantıdan QR | URL\'leri QR Koda Çevirin',
      description:
        'Herhangi bir web sitesi veya kampanya URL\'sini yapıştırın ve baskı ya da dijital kullanım için anında markalı bir QR kod oluşturun. Özel renkler, logolar ve yüksek çözünürlüklü indirmeler desteklenir.',
      keywords: ['bağlantıdan qr', 'url qr oluşturucu', 'web sitesi qr', 'bağlantı için qr', 'utm qr kod', 'qr pdf indir'],
    },
  },
  hero: {
    title: 'Gizli, marka hazır QR kodlar oluşturun — sonsuza dek ücretsiz.',
    subtitle: 'Her iş akışına uyan hızlı, gizli ve esnek bir QR aracı.',
    desc: 'Hesap olmadan, filigran olmadan ve veri yüklemeden yüksek kaliteli QR kodlar üretin ve tarayın.',
    ctaPrimary: 'QR Kod Oluştur',
    ctaSecondary: 'Mobilde dene',
  },
  info: {
    helpTitle: 'Yardım Merkezi',
    helpSubtitle: 'SSS & Destek',
    contactTitle: 'Bize Ulaşın',
    contactSubtitle: 'Sizden haber almayı isteriz.',
    privacyTitle: 'Gizlilik Politikası',
    termsTitle: 'Hizmet Şartları',
  },
  contactForm: {
    name: 'Ad',
    email: 'E-posta',
    message: 'Mesaj',
    send: 'Mesaj Gönder',
    orEmail: 'veya doğrudan şu adrese e-posta gönderin',
    sending: 'Gönderiliyor...',
    successTitle: 'Mesaj Gönderildi!',
    successMessage: 'Bizimle iletişime geçtiğiniz için teşekkürler. Kısa süre içinde dönüş yapacağız.',
    sendAnother: 'Başka bir mesaj gönder',
    errorMessage: 'Şu anda mesajınızı gönderemiyoruz. Lütfen support@yesqrcode.com adresine e-posta atın.',
  },
  generator: {
    highlights: {
      title: 'Gizli, marka hazır QR kodlar oluşturun — sonsuza dek ücretsiz.',
      subtitle: 'Her iş akışına uyan hızlı, gizli ve esnek bir QR aracı.',
      items: [
        {
          title: 'Önce gizlilik, cihaz üzerinde üretim',
          desc: 'QR kodlar yerel olarak oluşturulur — yükleme yok, takip yok, veri saklama yok.',
        },
        {
          title: 'Her kullanım için zengin özellikler',
          desc: 'URL, Wi‑Fi, vCard, barkod, logo, degradeler, çerçeveler — hepsi dahil.',
        },
        {
          title: 'Mobil uyumlu ve herkes için kolay',
          desc: 'Telefonlar ve dokunmatik etkileşimler için optimize edilmiştir.',
        },
        {
          title: 'Sonsuza dek ücretsiz, ticari kullanım için güvenli',
          desc: 'Hesap yok, filigran yok, tarama limiti yok — ekipler ve işletmeler için güvenilir.',
        },
      ],
    },
    featureSuite: {
      title: 'Gizlilik odaklı tam QR kod paketi',
      subtitle: 'Temiz, markalı ve yüksek kaliteli QR kodlar oluşturmak için ihtiyacınız olan her şey — tek yerde.',
      categories: [
        {
          title: 'İhtiyacınız olan tüm QR kod türleri',
          body: 'URL, Metin, Wi‑Fi, E-posta, Telefon, SMS, vCard, sosyal bağlantılar, YouTube, barkodlar. Asla süresi dolmayan statik kodlar.',
          items: [],
        },
        {
          title: 'Markalama & Tasarım',
          body: 'Logo güvenli kodlar, degradeler, çerçeveler, şekiller, köşeler ve tarama için optimize düzenler.',
          items: [],
        },
        {
          title: 'Çıktı & Kalite',
          body: 'Baskı ve dijital için ön ayarlarla yüksek kaliteli PNG, SVG ve PDF dışa aktarımları.',
          items: [],
        },
        {
          title: 'Global & Kullanılabilirlik',
          body: 'Çok dilli arayüz, mobil öncelikli tasarım ve çevrimdışı dostu iş akışı.',
          items: [],
        },
      ],
    },
    trust: {
      title: 'Üreticiler, ekipler ve markalar tarafından güvenilir',
      subtitle:
        'YesQRCode uzun süreli kampanyalar için hafif, öngörülebilir ve güvenli olacak şekilde tasarlandı — hesap yok, satıcı kilidi yok, gizli sınırlama yok.',
      items: ['Sıfır başlangıç', 'Öngörülebilir statik kodlar', 'Kurumsal güven: bulut işlemi yok', 'Tüm varlıklarda tutarlı marka'],
    },
    sectionContent: 'İçerik',
    sectionColors: 'Renkler',
    sectionLogo: 'Logo',
    sectionFrame: 'Çerçeve',
    sectionDesign: 'Tasarım',
    sectionCorrection: 'Hata Düzeltme',
    labelUrl: 'Web sitesi URL\'si',
    labelText: 'Düz Metin',
    labelSsid: 'Ağ Adı (SSID)',
    labelPassword: 'Şifre',
    labelEncryption: 'Şifreleme',
    labelFgColor: 'Ön Plan',
    labelBgColor: 'Arka Plan',
    labelFrameText: 'Çerçeve Metni',
    labelFrameColor: 'Çerçeve Rengi',
    placeholder: 'İçeriğinizi buraya girin...',
    placeholders: {
      url: 'https://example.com',
      text: 'Metni buraya girin',
      email: 'sizin@email.com',
      subject: 'Konu',
      message: 'Mesajınız...',
      phone: '+90 5xx xxx xx xx',
      ssid: 'MyWiFi',
      password: '***',
      barcode: '123456789012',
    },
    download: 'PNG İndir',
    downloadSvg: 'SVG İndir',
    generateButton: 'QR Kod Oluştur',
    copy: 'SVG Kopyala',
    uploadLogo: 'Görsel Yükle',
    preview: 'Önizleme',
    lowQuality: 'Düşük Kalite',
    highQuality: 'Yüksek Kalite',
    foreverFree: 'Sonsuza Dek Ücretsiz • Kayıt Yok • Ticari Kullanım',
    barcodeWarning: 'Çerçeve ve Logo gibi gelişmiş tasarım seçenekleri Barkodlar için kullanılamaz.',
    barcodeColors: 'Yine de aşağıdan Renkleri özelleştirebilirsiniz.',
    frameStyles: {
      none: 'Yok',
      simple: 'Basit',
      balloon: 'Balon',
      box: 'Kutu',
      badge: 'Rozet',
      polaroid: 'Polaroid',
      phone: 'Telefon',
      header: 'Başlık',
      corner: 'Köşe',
    },
    vCard: {
      firstName: 'Ad',
      lastName: 'Soyad',
      mobile: 'Cep',
      phone: 'Telefon',
      fax: 'Faks',
      email: 'E-posta',
      company: 'Şirket',
      job: 'Unvan',
      street: 'Adres',
      city: 'Şehir',
      zip: 'Posta Kodu',
      state: 'İl/İlçe',
      country: 'Ülke',
      website: 'Web sitesi',
    },
    types: {
      [QRType.URL]: 'URL',
      [QRType.TEXT]: 'Metin',
      [QRType.EMAIL]: 'E-posta',
      [QRType.PHONE]: 'Telefon',
      [QRType.SMS]: 'SMS',
      [QRType.WIFI]: 'Wi‑Fi',
      [QRType.VCARD]: 'vCard',
      [QRType.FACEBOOK]: 'Facebook',
      [QRType.TWITTER]: 'X (Twitter)',
      [QRType.YOUTUBE]: 'YouTube',
      [QRType.BARCODE]: 'Barkod',
    },
    guide: {
      title: 'Özel bir QR Kod nasıl oluşturulur?',
      steps: [],
    },
    gettingStarted: {
      title: 'Nasıl Kullanılır',
      steps: [
        {
          title: 'QR İçeriğini Ayarlayın',
          text: 'QR kodunuz için üstten bir içerik türü seçin (URL, Metin, E-posta...). Türü seçtikten sonra tüm seçenekleri görürsünüz. Tarandığında görünmesini istediğiniz alanları doldurun. QR kodunuz basıldıktan sonra içeriği değiştiremeyeceğiniz için doğruluğundan emin olun.',
        },
        {
          title: 'Tasarımı Özelleştirin',
          text: 'QR kodunuzun benzersiz görünmesini mi istiyorsunuz? Özel renk belirleyin ve standart şekilleri değiştirin. Köşeler ve gövde ayrı ayrı özelleştirilebilir. Galeriden seçerek veya kendi logonuzu yükleyerek logo ekleyin.',
        },
        {
          title: 'QR Kodu Oluşturun',
          text: 'Kaydırıcıyla piksel çözünürlüğünü ayarlayın. “İndir” düğmelerine tıklayarak QR kodunuzu kaydedin. Önizlemeyi tarayarak doğru çalıştığından emin olun. Baskı kalitesi PNG için yüksek çözünürlük kullanın.',
        },
        {
          title: 'Görseli İndirin',
          text: 'Artık QR kodunuzu .png, .svg veya .pdf olarak indirebilirsiniz. Tam tasarımlı vektör formatı istiyorsanız .svg seçin. SVG, Adobe Illustrator veya Inkscape gibi yazılımlarda kullanılabilir. Logo ve tasarım ayarları şu anda yalnızca .png ve .svg için geçerlidir.',
        },
      ],
    },
    about: {
      title: 'Ücretsiz, Gizlilik Odaklı QR Kod Paketi',
      subtitle:
        'Hesap, filigran veya veri yükleme olmadan yüksek kaliteli QR kodlar üretin ve tarayın. Baskı, markalama ve ticari kullanım için optimize edilmiştir.',
      features: [
        'Tüm popüler türler: URL, Metin, Wi‑Fi, vCard, SMS ve barkodlar',
        '%30\'a kadar hata düzeltme ile logo güvenli',
        'Özel şekiller, degradeler, renkler ve çerçeveler',
        'Süresi dolmayan statik QR kodlar',
        'Global ekipler için çok dilli arayüz',
      ],
      content: [
        {
          title: 'Logo güvenli QR kodlar',
          body: 'Taramada sorun yaşamadan logo ekleyin. %30\'a kadar hata düzeltme ile markalı kaplamalar ambalaj, menü ve tabelalarda okunabilir kalır.',
        },
        {
          title: 'Özel şekiller ve çerçeveler',
          body: 'Köşe şekillerini değiştirin, degrade uygulayın ve kampanyanıza uygun çerçeveleri seçin. Tasarım odaklı kontroller, kodlar markalı görünürken taranabilir kalmasını sağlar.',
        },
        {
          title: 'Birden çok içerik türü',
          body: 'Tek bir yerden URL, metin, Wi‑Fi, vCard, SMS ve barkod kodları üretin; ön ayarlar her format için kurulumu kolaylaştırır.',
        },
        {
          title: 'Uzun ömürlü statik kodlar',
          body: 'Süresi dolmayan ve tarama kısıtlaması olmayan statik QR kodlar oluşturun — uzun süreli kampanyalar ve basılı materyaller için ideal.',
        },
      ],
    },
    faq: {
      title: 'Sık Sorulan Sorular',
      items: [
        {
          q: 'QR kod nedir?',
          a: 'QR, Quick Response Code anlamına gelir ve 1994 yılında Denso Wave tarafından icat edilen bir barkod türüdür.',
        },
        {
          q: 'Oluşturulan QR kodları ticari amaçla kullanabilir miyim?',
          a: 'Evet, bu QR oluşturucu ile oluşturduğunuz tüm QR kodlar ücretsizdir ve istediğiniz gibi kullanabilirsiniz.',
        },
        {
          q: 'Oluşturulan QR kodların süresi doluyor mu?',
          a: 'Hayır, süresi dolmaz ve sonsuza dek çalışır! YesQRCode ile oluşturulan QR kodlar statiktir ve belirli bir süre sonra çalışmayı durdurmaz. Ancak içeriklerini sonradan düzenleyemezsiniz.',
        },
        {
          q: 'QR kodlar için tarama limiti var mı?',
          a: 'Limit yoktur ve oluşturulan QR kod sonsuza dek çalışır. İstediğiniz kadar tarayın!',
        },
        {
          q: 'YesQRCode verilerimi kaydediyor mu?',
          a: 'Verilerinizi hiçbir şekilde kaydetmiyor veya yeniden kullanmıyoruz. Performansı optimize etmek için QR kod görsellerinizi 24 saat süreyle sunucumuzda önbelleğe alıyoruz.',
        },
        {
          q: 'vCard QR kodum doğru alanları göstermiyor, neden?',
          a: 'Tüm QR tarayıcıları resmi vCard standardını takip etmez; bu da alanların karışmasına neden olabilir. Daha iyi sonuç için başka bir tarayıcı uygulaması deneyin.',
        },
        {
          q: 'QR kodum çalışmıyor, ne yapabilirim?',
          a: 'Bir QR kodun çalışmamasının birçok nedeni olabilir. Önce verilerinizi kontrol edin: URL\'deki küçük yazım hataları QR kodu bozabilir. vCard gibi bazı kodlar çok veri içerir; mümkünse veriyi azaltın. Logoyu kaldırıp tekrar deneyin. Ayrıca arka plan ile ön plan arasında yeterli kontrast olduğundan emin olun; ön plan her zaman arka plandan daha koyu olmalıdır.',
        },
        {
          q: 'YesQRCode tüm tarayıcılarda çalışır mı?',
          a: 'YesQRCode modern HTML5 destekli bir tarayıcı gerektirir ve resmi olarak Chrome, Firefox, Safari, Edge ve Internet Explorer 11\'i destekler.',
        },
      ],
    },
  },
  scanner: {
    title: 'QR ve Barkod Tara',
    subtitle: 'QR ve barkodları anında çözmek için kamera kullanın, görsel yükleyin veya yapıştırın.',
    cameraPermission: 'Kamera erişimi reddedildi. Lütfen tarayıcı ayarlarından izin verin.',
    result: 'Sonuç',
    copy: 'Kopyala',
    copied: 'Kopyalandı',
    open: 'Bağlantıyı Aç',
    delete: 'Sil',
    scanAgain: 'Tekrar Tara',
    privacy: 'İşleme tarayıcınızda yerel olarak yapılır. Dosyalar cihazınızdan çıkmaz.',
    upload: 'Görsel Yükle',
    paste: 'Yapıştır (Ctrl+V)',
    drop: 'Görseli buraya bırakın',
    retry: 'Tekrar Dene',
    errorAccessDenied: 'Kamera Erişimi Reddedildi',
    errorCamera: 'Lütfen tarayıcı ayarlarından kamera erişimine izin verin.',
    initializing: 'Kamera Başlatılıyor...',
    cameraActive: 'Kamera Aktif',
    scannedItems: 'Taranan Öğeler',
    recentScans: 'Son (yerel olarak saklanır)',
    clickToUpload: 'Yüklemek için tıklayın',
    newBadge: 'YENİ',
    tabCameraMobile: 'Kamera',
    tabCameraDesktop: 'Kamera ile Tara',
    emptyState: {
      title: 'Henüz tarama yok',
      desc: 'Başlamak için bir görsel yükleyin veya kamera sekmesini kullanın.',
    },
    highlights: {
      title: 'Hızlı ve gizli tarama',
      items: [
        { title: 'Cihaz üzerinde çözme', desc: 'Varsayılan olarak yükleme yok; hassas URL ve içerikler için güvenli.' },
        { title: 'Çok formatlı', desc: 'QR yanında UPC/EAN, Code 128, ITF ve daha fazlası.' },
        { title: 'Hızlı aksiyonlar', desc: 'Dosya bırakın, ekran görüntüsü yapıştırın veya canlı taramaya geçin.' },
        { title: 'Mobilde harika', desc: 'Telefonlar ve küçük ekranlar için optimize edilmiş arayüz ve kamera akışı.' },
      ],
    },
    intro: {
      title: 'Online QR ve Barkod Tarayıcı',
      body: 'Bir uygulama yüklemeden tarayıcınızın içinde QR kodları, UPC, EAN ve daha fazlasını çözün.',
    },
    howTo: {
      title: 'Nasıl taranır?',
      methods: [
        {
          title: 'Yöntem 1: Yükleme',
          steps: ['Görsel Yükle\'ye tıklayın', 'QR/barkodunuzu seçin', 'Anında sonucu alın'],
        },
        {
          title: 'Yöntem 2: Kamera',
          steps: ['Kamera sekmesini açın', 'İzin verin', 'QR/barkoda doğrultun'],
        },
      ],
    },
    features: {
      title: 'Neden bu tarayıcı?',
      items: [
        { title: 'Yerel geçmiş', desc: 'Son taramalar yalnızca cihazınızda saklanır; tekrar kopyalamaya/açmaya hazır.' },
        { title: 'Çevrimdışı görsel çözme', desc: 'Bağlantı kesilse bile görsel yükleyerek veya yapıştırarak çözün.' },
        { title: 'Hızlı işlemler', desc: 'Basitleştirilmiş kontrollerle sonuçları anında kopyalayın, açın veya silin.' },
      ],
    },
    useCases: {
      title: 'Popüler Kullanım Senaryoları',
      items: [
        { title: 'Perakende ve Alışveriş', desc: 'Ürün URL\'lerini, kuponları veya talimatları kontrol edin.' },
        { title: 'Envanter Ekipleri', desc: 'Barkodları doğrulayın ve stok güncellemelerini yönetin.' },
        { title: 'Günlük Kullanıcılar', desc: 'Menüleri, Wi‑Fi bağlantılarını veya kişi kartlarını hızlıca açın.' },
      ],
    },
    faq: {
      title: 'Tarayıcı SSS',
      items: [
        { q: 'Barkod tarayabilir miyim?', a: 'Evet. Tarayıcı QR kodların yanında Code 128, UPC, EAN, ITF ve daha fazlasını destekler.' },
        { q: 'Taramalarımı saklıyor musunuz?', a: 'Taramalar tarayıcınızdan çıkmaz; her şey cihazınızda kalır.' },
        { q: 'Ekran görüntüsü yapıştırabilir miyim?', a: 'Evet. Panodan yapıştırmak için Ctrl+V (Cmd+V) kullanın.' },
        { q: 'Çevrimdışı çalışır mı?', a: 'Görsel yükleme çevrimdışı çalışır; kamera ile tarama izin ve desteklenen tarayıcı gerektirir.' },
      ],
    },
  },
  blog: {
    title: 'İpuçları ve Rehberler',
    subtitle: 'QR deneyimleri için en iyi uygulamalar, pazarlama fikirleri ve ürün güncellemeleri.',
    readMore: 'Makaleyi oku',
    back: 'Bloga dön',
    notFound: 'Yazı bulunamadı',
  },
  common: {
    footer: 'Pazarlamacılar, tasarımcılar ve ekipler için güçlü bir QR oluşturma paketi.',
    privacy: 'Gizlilik',
    terms: 'Şartlar',
    contact: 'İletişim',
    scanToOpen: 'Mobilde açmak için tara',
    help: 'Yardım',
    free: 'Ücretsiz',
    product: 'Ürün',
    resources: 'Kaynaklar',
    company: 'Şirket',
    api: 'API (Yakında)',
    systemStatus: 'Sistemler Çalışıyor',
    footerDesc:
      'En gelişmiş QR kod oluşturucu ve tarayıcı. Hızlı, gizlilik odaklı ve kişisel/komersiyel kullanım için sonsuza dek ücretsiz.',
  },
};

